<template>
  <div class='my-info'>
    <h2>个人资料</h2>
    <div v-loading='loading' class='content'>
      <ul>
        <li class='avatar-wrapper'>
          <span class='label'>头像：</span>
          <img :src='avatar' alt='' class='avatar'>
          <span class='notice'>点击编辑</span>
          <input id='avatarFile' type='file' accept='image/*' name='' class='avatar-file' @change='selectAvatar'>
        </li>
        <li>
          <span class='label'>性别：</span>
          <div class='gender-wrapper' @click='toggleGender("MALE")'>
            <img v-if='gender === "MALE"' src='../assets/imgs/selected_on.png' alt='' class='icon'>
            <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
            <span>男</span>
          </div>
          <div class='gender-wrapper' @click='toggleGender("FEMALE")'>
            <img v-if='gender === "FEMALE"' src='../assets/imgs/selected_on.png' alt='' class='icon'>
            <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
            <span>女</span>
          </div>
        </li>
        <li>
          <span class='label'>姓名：</span>
          <input v-model='name' type='tel' class='input'>
        </li>
        <li>
          <span class='label'>手机：</span>
          <input v-model='phone' type='tel' class='input'>
        </li>
        <li>
          <span class='label'>学校：</span>
          <select v-model='selectedSchool' class='select' @change='selectSchool'>
            <option value='-1' disabled>请选择学校</option>
            <option v-for='(item,index) in schoolOptions' :key='index' :value='item.id'>{{ item.name }}</option>
          </select>
        </li>
        <li>
          <span class='label'>院系：</span>
          <select v-model='selectedCollege' class='select' @change='selectCollege' @focus='focusCollege'>
            <option value='-1' disabled>请选择院系</option>
            <option v-for='(item,index) in collegeOptions' :key='index' :value='item.id'>{{ item.name }}</option>
          </select>
        </li>
        <li>
          <span class='label'>班级：</span>
          <select v-model='selectedCls' class='select' @change='selectCls' @focus='focusCls'>
            <option value='-1' disabled>请选择专业班级</option>
            <option v-for='(item,index) in clsOptions' :key='index' :value='item.id'>{{ item.name }}</option>
          </select>
        </li>
        <li>
          <span class='label'>学号：</span>
          <input v-model='student_num' type='text' class='input'>
        </li>
      </ul>
      <div class='btn-wrapper'>
        <a href='javascript:;' class='btn-submit' @click='submitEdit'>保存</a>
        <a href='javascript:;' class='btn-cancel' @click='cancel'>取消</a>
      </div>
    </div>
  </div>
</template>

<script>
import { SCHOOL_LIST, COLLEGE_LIST, CLS_LIST, EDIT_USER_INFO } from '@/api'

export default {
  data() {
    return {
      name: '',
      phone: '',
      avatar: '',
      avatarFile: null,
      loading: false,
      gender: 'MALE',
      student_num: '',
      selectedSchool: '-1',
      selectedCollege: '-1',
      selectedCls: '-1',
      schoolOptions: [],
      collegeOptions: [],
      clsOptions: [],
    }
  },

  created() {
    this.setActiveBar('MY')
    this.getSchoolList()
    this.initUserInfo()

  },

  methods: {
    // 取消编辑
    cancel() {
      this.avatarFile = null
      this.goBack()
    },

    // 保存用户信息
    submitEdit() {
      let formData = new FormData()
      if (this.avatarFile) formData.append('file',this.avatarFile)
      formData.append('name',this.name)
      formData.append('student_num',this.student_num)
      formData.append('sex', this.gender === 'MALE' ? 1 : (this.gender === 'FEMALE' ? 2 : 0))
      formData.append('student_num', this.student_num)
      if (this.selectedSchool !== -1) formData.append('school_id',this.selectedSchool)
      if (this.selectedCollege !== -1) formData.append('department_id',this.selectedCollege)
      if (this.selectedCls !== -1) formData.append('profession_class_id',this.selectedCls)

      this.loading = true
      EDIT_USER_INFO(formData).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.$notify('保存成功')
          this.goBack()
        } else {
          this.$notify(res.data.msg, 'error')
        }
      })
    },

    // 选取头像
    selectAvatar(e) {
      let file = e.target.files[0]
      let render = new FileReader()
      render.onload = e=>{
        this.avatar = e.target.result
      }
      render.readAsDataURL(file)
      this.avatarFile = file
    },

    // 切换性别
    toggleGender(val) {
      this.gender = val
    },

    // 监听学院获取焦点事件
    focusCollege() {
      if (this.selectedSchool === '-1') {
        this.$notify('请先选择学校','warning')
      }
    },

    // 监听专业班级获取焦点事件
    focusCls() {
      if ((this.selectedSchool === '-1') || (this.selectedCollege === '-1')) {
        this.$notify('请先选择学校/院系','warning')
      }
    },

    // 获取学校
    getSchoolList() {
      SCHOOL_LIST().then(res=>{
        if (res.data.code === 0) {
          this.schoolOptions = res.data.data
          let payload = {
            type: 'SCHOOL',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 获取院系
    getCollegeList(para) {
      COLLEGE_LIST(para).then(res=>{
        if (res.data.code === 0) {
          this.collegeOptions = res.data.data
          let payload = {
            type: 'COLLEGE',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 获取班级
    getClsList(para) {
      CLS_LIST(para).then(res=>{
        if (res.data.code === 0) {
          this.clsOptions = res.data.data
          let payload = {
            type: 'CLS',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 选择学校 -> 获取院系
    selectSchool(e) {
      let para = {
        school_id: e.target.value
      }
      this.collegeOptions = []
      this.clsOptions = []
      this.getCollegeList(para)
      let payload = {
        type: 'SCHOOL',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 选择院系 -> 获取专业班级
    selectCollege(e) {
      let para = {
        department_id: e.target.value
      }
      this.clsOptions = []
      this.getClsList(para)
      let payload = {
        type: 'COLLEGE',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 选择班级
    selectCls(e) {
      let payload = {
        type: 'CLS',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 初始化个人信息
    initUserInfo() {
      let info = this.$store.state.userInfo
      this.avatar = info.avatar_path
      this.name = info.name
      this.gender = info.sex === 1 ? 'MALE' : (info.sex === 2 ? 'FEMALE' : '')    // 1： 男； 2：女； 0：未设置
      this.phone = info.phone
      this.student_num = info.student_num
      this.avatarFile = null
            
      if (info.school) {
        this.selectedSchool = info.school.id 
        let para = {
          school_id: info.school.id
        }
        this.getCollegeList(para)
      }
      if (info.department) {
        this.selectedCollege = info.department.id
        let para = {
          department_id: info.department.id
        }
        this.getClsList(para)
      }
      if (info.profession_class) {
        this.selectedCls = info.profession_class.id
      }
    }

  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.my-info {
  h2 {
    font-size: 20px;
    font-weight: 500;
    height: 67px;
    line-height: 67px;
    text-align: center;
  }
  .content {
    width: 860px;
    height: 695px;
    border-radius: 5px;
    background-color: @blue-l;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    margin-bottom: 30px;
    box-sizing: border-box;
    padding: 45px 0;
    position: relative;

    ul {
      li {
        height: 40px;
        line-height: 40px;
        margin-bottom: 5px;
        font-size: 18px;
        display: flex;
        flex-direction: row;
        align-items: center;

        &.avatar-wrapper {
          height: 74px;
          position: relative;
          .avatar {
            width: 74px;
            height: 74px;
            border-radius: 50%;
            cursor: pointer;
          }
          .notice {
            display: inline-block;
            height: 74px;
            font-size: 14px;
            color: #666666;
            margin-left: 20px;
            padding-top: 40px;
            box-sizing: border-box;
            cursor: pointer;
          }

          .avatar-file {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 300px;
            background-color: aqua;
            z-index: 9;
            opacity: 0;
            cursor: pointer;
          }
        }

        .label {
          display: inline-block;
          width: 314px;
          text-align: right;
        }

        .input {
          display: inline-block;
          height: 30px;
          width: 345px;
          line-height: 30px;
          border: none;
          outline: none;
          border-radius: 3px;
          font-size: 14px;
          padding-left: 5px;
          box-sizing: border-box;
        }

        .gender-wrapper {
          height: 40px;
          margin-right: 10px;
          width: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-around;
          cursor: pointer;
        }

        .select {
          display: inline-block;
          width: 345px;
          box-sizing: border-box;
          display: inline-block;
          height: 34px;
          border: 1px solid #dddddd;
          border-radius: 5px;
          background: #ffffff;
          outline: none;
          box-sizing: border-box;
          font-size: 14px;
        }
      }
    }

    .btn-wrapper {
      width: 300px;
      margin: 50px auto 0;

      a {
        display: block;
        height: 38px;
        line-height: 38px;
        color: #fff;
        font-size: 20px;
        text-align: center;
        border-radius: 5px;

        &.btn-submit {
          background: @blue-d;
          margin-bottom: 18px;
        }

        &.btn-cancel {
          background: #cccccc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MyInfo.vue